<template>
  <li
    class="main-nav__item"
    role="none"
    :class="{
      'has-sub': hasChildren,
      'is-hovered': isVisible,
      'is-mobile-only': displayMobileOnly,
    }"
  >
    <MegaMenuItemLink
      class="main-nav__link"
      label-class="main-nav__link-label"
      post-icon-class="main-nav__link-icon"
      :pre-icon="icon"
      :item="item"
      :has-drop="hasChildren"
      :aria-haspopup="hasChildren"
      :aria-expanded="isVisible"
      :route="route"
      role="menuitem"
      tabindex="0"
    />
    <template v-if="hasChildren">
      <MegaMenuItemDrop :is-visible="isVisible" :item="item" class="main-nav__sub" @link-click="onLinkClick" />
    </template>
  </li>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { getSelectValue } from '@/utils/blocks';
import { useLayoutNavStore } from '@/stores/layout-nav';
import MegaMenuItemDrop from '~/components/ui/layout/mega-menu/MegaMenuItemDrop.vue';
import MegaMenuItemLink from '~/components/ui/layout/mega-menu/MegaMenuItemLink.vue';

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  mobileOnly: {
    type: Boolean,
    default: false,
  },
  preIcon: {
    type: String,
    default: null,
  },
  route: {
    type: Object,
    default: null,
  },
});

const isVisible = ref(false);
const layoutNavStore = useLayoutNavStore();

const hasChildren = computed(() => {
  return Array.isArray(props.item.child_links) && props.item.child_links.length > 0;
});

const displayMobileOnly = computed(() => {
  return props.mobileOnly || props.item.mobile_only;
});

const icon = computed(() => {
  return props.preIcon || getSelectValue(props.item.mobile_icon, 'slug');
});

watch(
  () => layoutNavStore.openedNavItem,
  (opened) => {
    if (displayMobileOnly.value || !hasChildren.value) {
      isVisible.value = false;
      return;
    }

    isVisible.value = opened === props.item;
  },
  { immediate: true }
);

const onLinkClick = () => {
  document.documentElement.classList.remove('is-nav-over');
  layoutNavStore.toggleOpenedNavItem(null);
};
</script>
